import { inject, Injectable } from '@angular/core';
import { _, TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { IPosition } from '@app/core/interfaces/position.interface';
import { ClipboardCopyService } from '@app/core/services/clipboard-copy/clipboard-copy.service';
import { FormattingDataService } from '@app/core/services/formatting-data/formatting-data.service';
import { DoToolbarService } from '@app/main/main-content/display-options/services/do-toolbar/do-toolbar.service';
import { ldContextMenuTodo } from '@app/main/leak-detection/context-menus/utils/ld-context-menu-todo';

@Injectable({ providedIn: 'root' })
export class LdContextMenuMapAreaService {
  private readonly translateService = inject(TranslateService);
  private readonly formattingData = inject(FormattingDataService);
  private readonly clipboardCopy = inject(ClipboardCopyService);
  private readonly doToolbarService = inject(DoToolbarService);

  public getMapItems(position: IPosition): MenuItem[] {
    return [
      {
        label: this.translateService.instant(_(`@@shared-create-event__text`)),
        icon: 'icons/icon-plus.svg',
        command: () => ldContextMenuTodo('Create event', position),
      },
      {
        label: this.translateService.instant(_(`@@leak-detection-context-menu-create-pipe__label`)),
        icon: 'icons/icon-vector.svg',
        command: () => ldContextMenuTodo('Create pipe', position),
      },
      { separator: true },
      {
        label: this.translateService.instant(_(`@@leak-detection-context-menu-copy-coordinates__label`)),
        icon: 'icons/icon-copy-big.svg',
        command: () => this.clipboardCopy.copy(this.formattingData.formatCoordinates(position)),
      },
      { separator: true },
      {
        label: this.translateService.instant(_(`@@leak-detection-context-menu-zoom-to-fit__label`)),
        icon: 'icons/icon-zoom-to-fit.svg',
        // same toolbar toggle the display-options button uses — it fits everything currently shown
        command: () => this.doToolbarService.toggleZoomToFit(),
      },
    ];
  }
}
